'use client';
import Image from 'next/image';
import { useVideoViewport } from '@/hooks/useVideoViewport';

const BenefitPosterInner = ({ src }: { src: string }) => {
  return (
    <Image
      src={src}
      alt="Video preview"
      fill
      className="absolute inset-0 object-cover z-0"
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      priority={false}
    />
  );
};

export const BenefitPoster = ({ src }: { src: string }) => {
  return (
    <div className="relative aspect-square overflow-hidden">
      <Image
        src={src}
        alt="Video preview"
        fill
        className="absolute inset-0 object-cover z-0"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        priority={false}
      />
    </div>
  );
};

export const BenefitVideoSmall = ({ src, poster }: { src: string; poster?: string }) => {
  const videoRef = useVideoViewport({
    isCentered: true,
    centerTolerance: 25,
  });

  return (
    <div className="relative">
      <div className="relative aspect-square overflow-hidden">
        {/* Next.js optimized poster image - always present as background */}
        {poster && <BenefitPoster src={poster} />}

        {/* Video overlays the image when it load */}
        <video
          ref={videoRef}
          src={src}
          // loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover z-10"
        />
      </div>
    </div>
  );
};
